import { render, staticRenderFns } from "./creditItem.vue?vue&type=template&id=dc67fcea&scoped=true"
import script from "./creditItem.vue?vue&type=script&lang=js"
export * from "./creditItem.vue?vue&type=script&lang=js"
import style0 from "./creditItem.vue?vue&type=style&index=0&id=dc67fcea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc67fcea",
  null
  
)

export default component.exports